import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Turborepo 2.6",
  "description": "Microfrontends, Bun package manager to stable, task search in TUI",
  "date": "2025/10/28",
  "tag": "web development"
};
export let structuredData = {
  "contents": [{
    "heading": "turborepo-26",
    "content": "Turborepo 2.6 includes a number of improvements to developer experience for your repository:"
  }, {
    "heading": "turborepo-26",
    "content": "Microfrontends: Develop many applications on one localhost port"
  }, {
    "heading": "turborepo-26",
    "content": "Bun package manager to stable: Granular lockfile analysis and pruning for bun.lock"
  }, {
    "heading": "turborepo-26",
    "content": "Task list search in terminal UI: Use / to focus tasks faster"
  }, {
    "heading": "turborepo-26",
    "content": "Upgrade today by running npx @turbo/codemod migrate or get started with npx create-turbo@latest."
  }, {
    "heading": "microfrontends",
    "content": "Vertical microfrontends are an architecture where multiple applications are served on one production domain, split into \"zones\". Each path for the domain is handled by one of the applications."
  }, {
    "heading": "microfrontends",
    "content": "This strategy gives teams at scale the ability to ship more independently. Release cycles become decoupled, build times can be brought down, and CI pipelines can get more focused, among other benefits."
  }, {
    "heading": "microfrontends",
    "content": "While this does help production deployments, it can create difficulty for local development since you’ll have to run many applications instead of just one. Each application ends up needing its own development command and port to use."
  }, {
    "heading": "microfrontends",
    "content": "Today, we’re releasing a microfrontend proxy for local development, so that all of your applications can run on one port, with one command. Add a microfrontends.json file to your parent application and Turborepo will automatically proxy localhost:3024 to the ports for your other applications."
  }, {
    "heading": "microfrontends",
    "content": "Just run turbo dev. In this configuration, your docs app runs its development server on localhost:3001 and will handle requests for /docs and all nested paths in /docs. The web app runs on localhost:3000 and handles all other requests."
  }, {
    "heading": "microfrontends",
    "content": "Visit the documentation to learn more."
  }, {
    "heading": "integrating-with-production-infrastructure",
    "content": "While Turborepo’s native microfrontend proxy is meant for working locally, we’re deeply integrating with infrastructure providers to help you bring your microfrontends architecture to production."
  }, {
    "heading": "integrating-with-production-infrastructure",
    "content": "For example, we’ve designed the Turborepo-native microfrontends proxy to work with Vercel’s microfrontends product, which is also releasing to GA today. In fact, Vercel’s microfrontends feature provided the research for Turborepo-native microfrontends. We explored how to build microfrontends, locally and in production, with some of the largest customers at Vercel, and are now extracting those learnings from closed-source to open-source."
  }, {
    "heading": "integrating-with-production-infrastructure",
    "content": "When you install @vercel/microfrontends into your repository, Turborepo will dynamically adjust your local environment to use the proxy provided by the package, deeply integrating with your production infrastructure. Visit the Vercel microfrontends documentation to learn more."
  }, {
    "heading": "integrating-with-production-infrastructure",
    "content": "We look forward to working with more providers to integrate seamless microfrontends across your stack. If you are an infrastructure provider looking to integrate, please reach out."
  }, {
    "heading": "bun-package-manager-to-stable",
    "content": "Bun is a fast, incrementally adoptable all-in-one JavaScript, TypeScript & JSX toolkit. Today, Bun as a package manager is now stable in Turborepo."
  }, {
    "heading": "bun-package-manager-to-stable",
    "content": "This means that, when you use Bun as your package manager, Turborepo will only miss cache for packages that have changes in their dependencies. If you update a dependency for your web application, your docs application’s tasks will still hit cache."
  }, {
    "heading": "bun-package-manager-to-stable",
    "content": "Since September 2023, Turborepo has had Beta support for Bun’s package manager capabilities. Our first iteration worked with the original bun.lockb lockfile, though it didn’t have granular change detection, so any change to your dependencies would result in cache misses for your whole repository. Since then, Bun’s lockfiles have undergone several changes:"
  }, {
    "heading": "bun-package-manager-to-stable",
    "content": "In December 2024, Bun introduced the text-based bun.lock, with a v0 version. Because this file is text-based, Turborepo could parse it to intelligently cache tasks for your packages based on dependency changes."
  }, {
    "heading": "bun-package-manager-to-stable",
    "content": "In January 2025, bun.lock's format changed from a v0 to v1, breaking the parser we created for v0. A package manager’s lockfile isn’t part of its public API, and Bun got much faster because of this change, so we were excited to see the improvement. But we didn't know if we were going to need to rewrite a new parser every month..."
  }, {
    "heading": "bun-package-manager-to-stable",
    "content": "After a few months of stability and an inspiring blog post about the new lockfile format by the Bun team, Turborepo now handles the latest v1 lockfile format for Bun."
  }, {
    "heading": "bun-package-manager-to-stable",
    "content": "We’ve updated our Support Policy and the rest of our documentation to reflect this update. We also want to thank the Bun team for sending robobun to help us with the first draft of the PR."
  }, {
    "heading": "task-list-search-in-terminal-ui",
    "content": "The terminal UI in Turborepo was early to today’s trend of TUI-based experiences that we’re seeing in many AI-based workflows. Turborepo’s terminal UI brings many benefits compared to streamed logs, including improved readability for task logs, easy copy-paste for a specific task, interactive tasks, and more."
  }, {
    "heading": "task-list-search-in-terminal-ui",
    "content": "But in large repositories, it can be slow to scroll through a large list of tens or hundreds of tasks, one-by-one."
  }, {
    "heading": "task-list-search-in-terminal-ui",
    "content": "Today, we’re improving on our task search to make it one of the fundamental ways that you interact with a large Turborepo. When using the terminal UI, press / to filter to only the tasks that you’re interested in."
  }, {
    "heading": "task-list-search-in-terminal-ui",
    "content": "Only the tasks that match your search query will be selected. Visit the terminal UI documentation to learn more."
  }, {
    "heading": "other-changes",
    "content": "feat(tui): more keybinds for scrolling (#10248)"
  }, {
    "heading": "other-changes",
    "content": "feat(tui): configurable scrollback length (#10247)"
  }, {
    "heading": "other-changes",
    "content": "feat(codemod): update $schema when versioned (#10319)"
  }, {
    "heading": "other-changes",
    "content": "feat(sidebar): improve folder link accessibility and UX (#10349)"
  }, {
    "heading": "other-changes",
    "content": "feat(ls): add dependents to json output (#10367)"
  }, {
    "heading": "other-changes",
    "content": "feat(dry): include with in dry run/summary output (#10373)"
  }, {
    "heading": "other-changes",
    "content": "feat(ui): remove gutter from persisted task output (#10406)"
  }, {
    "heading": "other-changes",
    "content": "feat(tui): momentum-based scrolling (#10420)"
  }, {
    "heading": "other-changes",
    "content": "feat(turbo.json): allow for trailing commas (#10537)"
  }, {
    "heading": "other-changes",
    "content": "feat(env): add Windows user profile variables to pass-through (#10588)"
  }, {
    "heading": "other-changes",
    "content": "feat(auth): optional callback port (#10666)"
  }, {
    "heading": "other-changes",
    "content": "feat(create-turbo): --no-git flag (#10720)"
  }, {
    "heading": "other-changes",
    "content": "feat(tui): add shortcut for clearing task logs (#10828)"
  }, {
    "heading": "other-changes",
    "content": "feat: new OAuth flow for Turborepo CLI with Vercel (#10911)"
  }, {
    "heading": "other-changes",
    "content": "feat: update create-turbo Bun prompt text (#10918)"
  }, {
    "heading": "other-changes",
    "content": "feat(microfrontends): schema.json for microfrontends.json (#11008)"
  }, {
    "heading": "other-changes",
    "content": "feat: Add support for custom microfrontends.json naming (#11022)"
  }, {
    "heading": "other-changes",
    "content": "fix(microfrontends): ensure that local proxy is loose (#10289)"
  }, {
    "heading": "other-changes",
    "content": "fix(codemod): check for pipeline key before using it (#10295)"
  }, {
    "heading": "other-changes",
    "content": "fix(@turbo/repository): no longer require packageManager to detect npm (#10314)"
  }, {
    "heading": "other-changes",
    "content": "fix(watch): allow usage of turbo.jsonc (#10340)"
  }, {
    "heading": "other-changes",
    "content": "fix(dry): do not perform runtime validations on dry runs (#10375)"
  }, {
    "heading": "other-changes",
    "content": "fix(microfrontends): respect packageName field (#10383)"
  }, {
    "heading": "other-changes",
    "content": "fix(pnpm): read linkWorkspacePackages from pnpm-workspace.yaml (#10391)"
  }, {
    "heading": "other-changes",
    "content": "fix(query): use patched version of async-graphql (#10448)"
  }, {
    "heading": "other-changes",
    "content": "fix(turbo-ignore): no longer attempt to use catalog protocol (#10458)"
  }, {
    "heading": "other-changes",
    "content": "fix(@turbo/repository): correct exports from native lib (#10475)"
  }, {
    "heading": "other-changes",
    "content": "fix(turbo): pass through pnpm store env vars by default (#10520)"
  }, {
    "heading": "other-changes",
    "content": "fix(pnpm): respect deep for linkWorkspacePackages (#10558)"
  }, {
    "heading": "other-changes",
    "content": "fix(query): pin to last graphiql version with artifacts (#10685)"
  }, {
    "heading": "other-changes",
    "content": "fix(logs): no longer output group prefixes if no logs present (#10760)"
  }, {
    "heading": "other-changes",
    "content": "fix(turbo): graceful shutdown on sighup (#10764)"
  }, {
    "heading": "other-changes",
    "content": "fix(logs): create log files for non-cached tasks (#10806)"
  }, {
    "heading": "other-changes",
    "content": "fix(security): update dependencies to resolve warning for node-plop (#10847)"
  }, {
    "heading": "other-changes",
    "content": "fix: revert #10847 (#10882)"
  }, {
    "heading": "other-changes",
    "content": "fix: update ui suggested value in error message for turbo.json (#10896)"
  }, {
    "heading": "other-changes",
    "content": "fix(eslint-config-turbo): use module.exports for ESLint v8 compatibility (#10902)"
  }, {
    "heading": "other-changes",
    "content": "fix(turborepo-lockfiles): handle missing optional dependencies in Bun lockfiles (#10909)"
  }, {
    "heading": "other-changes",
    "content": "fix(lockfiles): include bundled dependencies in Bun lockfile subgraphs (#10915)"
  }, {
    "heading": "other-changes",
    "content": "fix: update remote cache OAuth refresh flow (#10916)"
  }, {
    "heading": "other-changes",
    "content": "fix: --graph=foo.dot should not require graphviz installed (#10942)"
  }, {
    "heading": "other-changes",
    "content": "fix: injectWorkspacePackages for turbo prune with pnpm (#10945)"
  }, {
    "heading": "other-changes",
    "content": "fix: adjust binary call for microfrontends proxy on Windows (#10962)"
  }, {
    "heading": "other-changes",
    "content": "fix: added Linux env vars to global passthroughs (#10984)"
  }, {
    "heading": "other-changes",
    "content": "fix: windows symlinking bug (#10992)"
  }, {
    "heading": "other-changes",
    "content": "fix: path validation in microfrontends.json (#11006)"
  }, {
    "heading": "other-changes",
    "content": "docs: clarification on Transit Nodes docs (#9181)"
  }, {
    "heading": "other-changes",
    "content": "fix(docs): fix SVG attribute casing to remove React warnings (#10297)"
  }, {
    "heading": "other-changes",
    "content": "fix(docs): update redirects rule to resolve access issue on getting-started index page (#10296)"
  }, {
    "heading": "other-changes",
    "content": "docs(fix): persist tabs state (#10313)"
  }, {
    "heading": "other-changes",
    "content": "docs(chore): remove classnames dependency (#10339)"
  }, {
    "heading": "other-changes",
    "content": "docs(chore): remove /repo references from a few places (#10370)"
  }, {
    "heading": "other-changes",
    "content": "docs(chore): add robots.txt (#10371)"
  }, {
    "heading": "other-changes",
    "content": "docs(fix): better usability on feedback form (#10382)"
  }, {
    "heading": "other-changes",
    "content": "docs(fix): logos when using system theme (#10388)"
  }, {
    "heading": "other-changes",
    "content": "docs(chore): switch to ESM (#10405)"
  }, {
    "heading": "other-changes",
    "content": "docs(fix): date of 2.5 release post (#10419)"
  }, {
    "heading": "other-changes",
    "content": "docs(chore): temporarily revert to webpack (#10421)"
  }, {
    "heading": "other-changes",
    "content": "docs(fix): layout shift on home page (#10424)"
  }, {
    "heading": "other-changes",
    "content": "docs(chore): cleaning up a few todos (#10426)"
  }, {
    "heading": "other-changes",
    "content": "docs(chore): reenable Turbopack (#10428)"
  }, {
    "heading": "other-changes",
    "content": "docs(examples): drop JS config from Tailwind example (#10445)"
  }, {
    "heading": "other-changes",
    "content": "docs(fix): correct globalDependencies defaults (#10484)"
  }, {
    "heading": "other-changes",
    "content": "docs(example): use npx turbo and show filtering (#10500)"
  }, {
    "heading": "other-changes",
    "content": "docs(fix): use pnpm add <pkg> instead of pnpm install <pkg> (#10529)"
  }, {
    "heading": "other-changes",
    "content": "docs(fix): missing commas in package.json files of jest docs (#10560)"
  }, {
    "heading": "other-changes",
    "content": "docs(fix): css import order bug in tailwindcss docs and example (#10561)"
  }, {
    "heading": "other-changes",
    "content": "docs(fix): incorrect CSS filename in Tailwind CSS setup example (#10573)"
  }, {
    "heading": "other-changes",
    "content": "docs(fix): inconsistent command with the illustration (#10596)"
  }, {
    "heading": "other-changes",
    "content": "docs(fix): inconsistent turbo command with the illustration (#10602)"
  }, {
    "heading": "other-changes",
    "content": "docs: fix JSDoc type for ESLint config in basic example (#10727)"
  }, {
    "heading": "other-changes",
    "content": "docs(run): correct --graph formats; remove incorrect default mention (#10744)"
  }, {
    "heading": "other-changes",
    "content": "docs(run): fix --log-prefix options to match CLI (task, not prefix) (#10743)"
  }, {
    "heading": "other-changes",
    "content": "fix(docs): fix broken anchor links to --graph option (#10773)"
  }, {
    "heading": "other-changes",
    "content": "docs: add GitHub Actions reusable workflow documentation for remote caching (#10923)"
  }, {
    "heading": "other-changes",
    "content": "docs: generate blog release OG images (#10936)"
  }, {
    "heading": "other-changes",
    "content": "docs: fix correct package name from eslint-config-turbo to eslint-plugin-turbo (#10954)"
  }, {
    "heading": "other-changes",
    "content": "docs: adjust compute hours saved component initial value (#10958)"
  }, {
    "heading": "other-changes",
    "content": "docs: align tailwindcss 4 guide to the with-tailwind example  (#10963)"
  }, {
    "heading": "other-changes",
    "content": "docs: fix typos and formatting issues in Playwright guide (#10980)"
  }, {
    "heading": "other-changes",
    "content": "docs: clarify passthrough args comparison (#10990)"
  }, {
    "heading": "other-changes",
    "content": "docs: fix profile images on home page (#10993)"
  }, {
    "heading": "other-changes",
    "content": "docs: Clarify passthrough args cache miss (#11026)"
  }, {
    "heading": "other-changes",
    "content": "refactor(examples): enhance with-nestjs (#8131) (#10964)"
  }, {
    "heading": "other-changes",
    "content": "fix(examples): fix build in fresh vue example project (#10277)"
  }, {
    "heading": "other-changes",
    "content": "fix(non-monorepo): correct devDependency from 'turb' to 'turbo' (#10526)"
  }, {
    "heading": "other-changes",
    "content": "fix(examples): change docker command (#10362)"
  }, {
    "heading": "other-changes",
    "content": "fix(examples): with-svelte classes (#10363)"
  }, {
    "heading": "other-changes",
    "content": "feat(examples): upgrade with-tailwind to TailwindCSS v4 (#10432)"
  }, {
    "heading": "other-changes",
    "content": "fix(examples): TypeScript in with-svelte example (#10450)"
  }, {
    "heading": "other-changes",
    "content": "feat(example): update with-react-native-web, Expo SDK 52 (#10466)"
  }, {
    "heading": "other-changes",
    "content": "fix(examples): use entry instead of entryPoints (#10503)"
  }, {
    "heading": "other-changes",
    "content": "fix(example/with-docker): jest can't resolve @repo/jest-presets/node (#10551)"
  }, {
    "heading": "other-changes",
    "content": "fix(example): add missing Tailwind import to shared ui styles (#10579)"
  }, {
    "heading": "other-changes",
    "content": "refactor(examples): remove duplicate Next.js plugin from app tsconfig files (#10612)"
  }, {
    "heading": "other-changes",
    "content": "fix(examples): css specificity in Tailwind example (#10657)"
  }, {
    "heading": "other-changes",
    "content": "refactor(examples): update CSS variable names to use consistent --color- prefix in tailwind examples (#10662)"
  }, {
    "heading": "other-changes",
    "content": "fix(examples): vitest version upgrade (#10667)"
  }, {
    "heading": "other-changes",
    "content": "fix(examples): update vitest config paths for packages and apps in with-vitest (#10675)"
  }, {
    "heading": "other-changes",
    "content": "fix(examples): correct 'test:projects' script to use vitest directly (#10683)"
  }, {
    "heading": "other-changes",
    "content": "fix(examples): add missing extension to with-react-native-web ui tsconfig (#10694)"
  }, {
    "heading": "other-changes",
    "content": "examples: Upgrade core-team-maintained examples to Next.js 16 (#11014)"
  }, {
    "heading": "acknowledgments-and-community",
    "content": "Turborepo is the result of the combined work of all of its contributors, including our core team: Anthony and Tom."
  }, {
    "heading": "acknowledgments-and-community",
    "content": "Thank you for your continued support, feedback, and collaboration to make Turborepo your build tool of choice. To learn how to get involved, visit the Community page."
  }, {
    "heading": "acknowledgments-and-community",
    "content": "We also thank everyone who contributed to this release of Turborepo: @0ri0nexe, @0xmuon, @ahlimanhuseynov, @Alvi24, @andrewjdimola, @ashishkumar901336, @aviramha, @brunoapaulino, @chris-olszewski, @d0lwl0b, @DiegoDev2, @dstewart1911, @emilbjorklund, @eric-hjh, @esauri, @eug-vs, @evsasse, @felipetau, @Franck-Fernandez-pro, @grgsh, @haklee, @hijuliancode, @hugomassing, @JacksonSL, @JamesHenry, @jeonghwan-park, @jferrettiboke, @jihwan1211, @JoeyKamsteeg, @kade-robertson, @kenfdev, @kitfoster, @leopardracer, @mamuso, @mcky, @melroy, @MendyLanda, @mischnic, @mknichel, @mrr11k, @namidapoo, @NathanM2000, @neonerdy, @nivekithan, @ognevny, @oliveirabalsa, @pawbor, @pzion, @Redddy, @richardhuf84, @robbym, @robobun, @safaiyeh, @sahyl, @Satheeshsk369, @schwenkm, @sdavids, @shinjith-dev, @sitek94, @tedw, @tetzng, @vikhyathdevadiga, @xcfio, @yam-codes, and @yamadayutaka"
  }],
  "headings": [{
    "id": "turborepo-26",
    "content": "Turborepo 2.6"
  }, {
    "id": "microfrontends",
    "content": "Microfrontends"
  }, {
    "id": "integrating-with-production-infrastructure",
    "content": "Integrating with production infrastructure"
  }, {
    "id": "bun-package-manager-to-stable",
    "content": "Bun package manager to stable"
  }, {
    "id": "task-list-search-in-terminal-ui",
    "content": "Task list search in terminal UI"
  }, {
    "id": "other-changes",
    "content": "Other changes"
  }, {
    "id": "acknowledgments-and-community",
    "content": "Acknowledgments and community"
  }]
};
import {Authors} from '#components/authors';
import {PackageManagerTabs, Tab} from '#components/tabs';
import {Date} from '#components/blog/date';
import {Accordion, Accordions} from '#components/accordion';
import {ThemeAwareImage} from '#components/theme-aware-image';
export const toc = [{
  depth: 1,
  url: "#turborepo-26",
  title: _jsx(_Fragment, {
    children: "Turborepo 2.6"
  })
}, {
  depth: 2,
  url: "#microfrontends",
  title: _jsx(_Fragment, {
    children: "Microfrontends"
  })
}, {
  depth: 3,
  url: "#integrating-with-production-infrastructure",
  title: _jsx(_Fragment, {
    children: "Integrating with production infrastructure"
  })
}, {
  depth: 2,
  url: "#bun-package-manager-to-stable",
  title: _jsx(_Fragment, {
    children: "Bun package manager to stable"
  })
}, {
  depth: 2,
  url: "#task-list-search-in-terminal-ui",
  title: _jsx(_Fragment, {
    children: "Task list search in terminal UI"
  })
}, {
  depth: 2,
  url: "#other-changes",
  title: _jsx(_Fragment, {
    children: "Other changes"
  })
}, {
  depth: 2,
  url: "#acknowledgments-and-community",
  title: _jsx(_Fragment, {
    children: "Acknowledgments and community"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h1: "h1",
    h2: "h2",
    h3: "h3",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h1, {
      id: "turborepo-26",
      children: "Turborepo 2.6"
    }), "\n", _jsx(Date, {
      children: "Tuesday, October 28th, 2025"
    }), "\n", _jsx(Authors, {
      authors: ['anthonyshew', 'tomknickman']
    }), "\n", _jsx(_components.p, {
      children: "Turborepo 2.6 includes a number of improvements to developer experience for your repository:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#microfrontends",
          children: _jsx(_components.strong, {
            children: "Microfrontends"
          })
        }), ": Develop many applications on one ", _jsx(_components.code, {
          children: "localhost"
        }), " port"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#bun-package-manager-to-stable",
          children: _jsx(_components.strong, {
            children: "Bun package manager to stable"
          })
        }), ": Granular lockfile analysis and pruning for ", _jsx(_components.code, {
          children: "bun.lock"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#task-list-search-in-terminal-ui",
          children: _jsx(_components.strong, {
            children: "Task list search in terminal UI"
          })
        }), ": Use ", _jsx(_components.code, {
          children: "/"
        }), " to focus tasks faster"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Upgrade today by running ", _jsx(_components.code, {
        children: "npx @turbo/codemod migrate"
      }), " or get started with ", _jsx(_components.code, {
        children: "npx create-turbo@latest"
      }), "."]
    }), "\n", _jsxs(PackageManagerTabs, {
      children: [_jsx(Tab, {
        value: "pnpm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-comment)",
                    "--shiki-dark": "var(--shiki-token-comment)"
                  },
                  children: "# Use the automated upgrade CLI"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "pnpm"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " dlx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " @turbo/codemod"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " migrate"
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: " "
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-comment)",
                    "--shiki-dark": "var(--shiki-token-comment)"
                  },
                  children: "# Start a new repository"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "pnpm"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " dlx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " create-turbo@latest"
                })]
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "yarn",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-comment)",
                    "--shiki-dark": "var(--shiki-token-comment)"
                  },
                  children: "# Use the automated upgrade CLI"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "yarn"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " dlx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " @turbo/codemod"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " migrate"
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: " "
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-comment)",
                    "--shiki-dark": "var(--shiki-token-comment)"
                  },
                  children: "# Start a new repository"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "yarn"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " dlx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " create-turbo@latest"
                })]
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "npm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-comment)",
                    "--shiki-dark": "var(--shiki-token-comment)"
                  },
                  children: "# Use the automated upgrade CLI"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "npx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " @turbo/codemod"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " migrate"
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: " "
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-comment)",
                    "--shiki-dark": "var(--shiki-token-comment)"
                  },
                  children: "# Start a new repository"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "npx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " create-turbo@latest"
                })]
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "bun",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-comment)",
                    "--shiki-dark": "var(--shiki-token-comment)"
                  },
                  children: "# Use the automated upgrade CLI"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "bunx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " @turbo/codemod"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " migrate"
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: " "
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-comment)",
                    "--shiki-dark": "var(--shiki-token-comment)"
                  },
                  children: "# Start a new repository"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "bunx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " create-turbo@latest"
                })]
              })]
            })
          })
        })
      })]
    }), "\n", _jsx(_components.h2, {
      id: "microfrontends",
      children: "Microfrontends"
    }), "\n", _jsx(_components.p, {
      children: "Vertical microfrontends are an architecture where multiple applications are served on one production domain, split into \"zones\". Each path for the domain is handled by one of the applications."
    }), "\n", _jsx(ThemeAwareImage, {
      className: "my-4 flex justify-center",
      light: {
        alt: '',
        src: '/images/blog/turbo-2-6/microfrontends-light.png',
        props: {
          width: 1600,
          height: 750,
          className: 'dark:hidden block rounded-xl'
        }
      },
      dark: {
        alt: '',
        src: '/images/blog/turbo-2-6/microfrontends-dark.png',
        props: {
          width: 1600,
          height: 750,
          className: 'hidden dark:block rounded-xl'
        }
      }
    }), "\n", _jsx(_components.p, {
      children: "This strategy gives teams at scale the ability to ship more independently. Release cycles become decoupled, build times can be brought down, and CI pipelines can get more focused, among other benefits."
    }), "\n", _jsx(_components.p, {
      children: "While this does help production deployments, it can create difficulty for local development since you’ll have to run many applications instead of just one. Each application ends up needing its own development command and port to use."
    }), "\n", _jsxs(_components.p, {
      children: ["Today, we’re releasing a microfrontend proxy for local development, so that all of your applications can run on one port, with one command. Add a ", _jsx(_components.code, {
        children: "microfrontends.json"
      }), " file to your parent application and Turborepo will automatically proxy ", _jsx(_components.code, {
        children: "localhost:3024"
      }), " to the ports for your other applications."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./apps/web/microfrontends.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"$schema\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"https://turborepo.com/microfrontends/schema.json\""
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "  \"applications\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ": {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"web\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"development\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "        \"local\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " 3000"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "      }"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"docs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"development\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "        \"local\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " 3001"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "      }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"routing\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "        {"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "          \"paths\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"/docs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"/docs/:path*\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "        }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "      ]"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Just run ", _jsx(_components.code, {
        children: "turbo dev"
      }), ". In this configuration, your ", _jsx(_components.code, {
        children: "docs"
      }), " app runs its development server on ", _jsx(_components.code, {
        children: "localhost:3001"
      }), " and will handle requests for ", _jsx(_components.code, {
        children: "/docs"
      }), " and all nested paths in ", _jsx(_components.code, {
        children: "/docs"
      }), ". The ", _jsx(_components.code, {
        children: "web"
      }), " app runs on ", _jsx(_components.code, {
        children: "localhost:3000"
      }), " and handles all other requests."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "/docs/guides/microfrontends",
        children: "Visit the documentation"
      }), " to learn more."]
    }), "\n", _jsx(_components.h3, {
      id: "integrating-with-production-infrastructure",
      children: "Integrating with production infrastructure"
    }), "\n", _jsx(_components.p, {
      children: "While Turborepo’s native microfrontend proxy is meant for working locally, we’re deeply integrating with infrastructure providers to help you bring your microfrontends architecture to production."
    }), "\n", _jsxs(_components.p, {
      children: ["For example, we’ve designed the Turborepo-native microfrontends proxy to work with ", _jsx(_components.a, {
        href: "http://vercel.com/microfrontends",
        children: "Vercel’s microfrontends product"
      }), ", which is also releasing to GA today. In fact, Vercel’s microfrontends feature provided the research for Turborepo-native microfrontends. We explored how to build microfrontends, locally and in production, with some of the largest customers at Vercel, and are now extracting those learnings from closed-source to open-source."]
    }), "\n", _jsxs(_components.p, {
      children: ["When you install ", _jsx(_components.a, {
        href: "https://www.npmjs.com/package/@vercel/microfrontends?activeTab=readme",
        children: _jsx(_components.code, {
          children: "@vercel/microfrontends"
        })
      }), " into your repository, Turborepo will dynamically adjust your local environment to use the proxy provided by the package, deeply integrating with your production infrastructure. ", _jsx(_components.a, {
        href: "https://vercel.com/docs/microfrontends",
        children: "Visit the Vercel microfrontends documentation"
      }), " to learn more."]
    }), "\n", _jsx(_components.p, {
      children: "We look forward to working with more providers to integrate seamless microfrontends across your stack. If you are an infrastructure provider looking to integrate, please reach out."
    }), "\n", _jsx(_components.h2, {
      id: "bun-package-manager-to-stable",
      children: "Bun package manager to stable"
    }), "\n", _jsx(_components.p, {
      children: "Bun is a fast, incrementally adoptable all-in-one JavaScript, TypeScript & JSX toolkit. Today, Bun as a package manager is now stable in Turborepo."
    }), "\n", _jsxs(_components.p, {
      children: ["This means that, when you use Bun as your package manager, Turborepo will only miss cache for packages that have changes in their dependencies. If you update a dependency for your ", _jsx(_components.code, {
        children: "web"
      }), " application, your ", _jsx(_components.code, {
        children: "docs"
      }), " application’s tasks will still hit cache."]
    }), "\n", _jsxs(_components.p, {
      children: ["Since September 2023, Turborepo has had Beta support for Bun’s package manager capabilities. Our first iteration worked with the original ", _jsx(_components.code, {
        children: "bun.lockb"
      }), " lockfile, though it didn’t have granular change detection, so any change to your dependencies would result in cache misses for your whole repository. Since then, Bun’s lockfiles have undergone several changes:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["In December 2024, Bun introduced the text-based ", _jsx(_components.code, {
          children: "bun.lock"
        }), ", with a ", _jsx(_components.code, {
          children: "v0"
        }), " version. Because this file is text-based, Turborepo could parse it to intelligently cache tasks for your packages based on dependency changes."]
      }), "\n", _jsxs(_components.li, {
        children: ["In January 2025, ", _jsx(_components.code, {
          children: "bun.lock"
        }), "'s format changed from a ", _jsx(_components.code, {
          children: "v0"
        }), " to ", _jsx(_components.code, {
          children: "v1"
        }), ", breaking the parser we created for ", _jsx(_components.code, {
          children: "v0"
        }), ". A package manager’s lockfile isn’t part of its public API, and Bun got much faster because of this change, so we were excited to see the improvement. But we didn't know if we were going to need to rewrite a new parser every month..."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["After a few months of stability and ", _jsx(_components.a, {
        href: "https://bun.com/blog/behind-the-scenes-of-bun-install",
        children: "an inspiring blog post about the new lockfile format by the Bun team"
      }), ", Turborepo now handles the latest ", _jsx(_components.code, {
        children: "v1"
      }), " lockfile format for Bun."]
    }), "\n", _jsxs(_components.p, {
      children: ["We’ve updated ", _jsx(_components.a, {
        href: "/docs/support-policy#package-managers",
        children: "our Support Policy"
      }), " and the rest of our documentation to reflect this update. We also want to thank the Bun team for ", _jsxs(_components.a, {
        href: "https://github.com/vercel/turborepo/pull/10729",
        children: ["sending ", _jsx(_components.code, {
          children: "robobun"
        }), " to help us with the first draft of the PR"]
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "task-list-search-in-terminal-ui",
      children: "Task list search in terminal UI"
    }), "\n", _jsx(_components.p, {
      children: "The terminal UI in Turborepo was early to today’s trend of TUI-based experiences that we’re seeing in many AI-based workflows. Turborepo’s terminal UI brings many benefits compared to streamed logs, including improved readability for task logs, easy copy-paste for a specific task, interactive tasks, and more."
    }), "\n", _jsx(_components.p, {
      children: "But in large repositories, it can be slow to scroll through a large list of tens or hundreds of tasks, one-by-one."
    }), "\n", _jsxs(_components.p, {
      children: ["Today, we’re improving on our task search to make it one of the fundamental ways that you interact with a large Turborepo. When using the terminal UI, press ", _jsx(_components.code, {
        children: "/"
      }), " to filter to only the tasks that you’re interested in."]
    }), "\n", _jsx(ThemeAwareImage, {
      className: "my-4 flex justify-center",
      light: {
        alt: 'A terminal window showing Turborepo\'s terminal UI. The top bar shows a search query for "docs" and the task list has dimmed every task except the tasks containing the name "docs".',
        src: '/images/blog/turbo-2-6/task-search-light.png',
        props: {
          width: 682,
          height: 746.5,
          className: 'dark:hidden block rounded-xl'
        }
      },
      dark: {
        alt: 'A terminal window showing Turborepo\'s terminal UI. The top bar shows a search query for "docs" and the task list has dimmed every task except the tasks containing the name "docs".',
        src: '/images/blog/turbo-2-6/task-search-dark.png',
        props: {
          width: 682,
          height: 746.5,
          className: 'hidden dark:block rounded-xl'
        }
      }
    }), "\n", _jsxs(_components.p, {
      children: ["Only the tasks that match your search query will be selected. ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/developing-applications#using-the-terminal-ui",
        children: "Visit the terminal UI documentation"
      }), " to learn more."]
    }), "\n", _jsx(_components.h2, {
      id: "other-changes",
      children: "Other changes"
    }), "\n", _jsxs(Accordions, {
      children: [_jsx(Accordion, {
        title: "Features (17)",
        children: _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: ["feat(tui): more keybinds for scrolling (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10248",
              children: "#10248"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["feat(tui): configurable scrollback length (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10247",
              children: "#10247"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["feat(codemod): update ", _jsx(_components.code, {
              children: "$schema"
            }), " when versioned (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10319",
              children: "#10319"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["feat(sidebar): improve folder link accessibility and UX (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10349",
              children: "#10349"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["feat(ls): add dependents to json output (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10367",
              children: "#10367"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["feat(dry): include ", _jsx(_components.code, {
              children: "with"
            }), " in dry run/summary output (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10373",
              children: "#10373"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["feat(ui): remove gutter from persisted task output (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10406",
              children: "#10406"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["feat(tui): momentum-based scrolling (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10420",
              children: "#10420"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["feat(turbo.json): allow for trailing commas (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10537",
              children: "#10537"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["feat(env): add Windows user profile variables to pass-through (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10588",
              children: "#10588"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["feat(auth): optional callback port (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10666",
              children: "#10666"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["feat(create-turbo): ", _jsx(_components.code, {
              children: "--no-git"
            }), " flag (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10720",
              children: "#10720"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["feat(tui): add shortcut for clearing task logs (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10828",
              children: "#10828"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["feat: new OAuth flow for Turborepo CLI with Vercel (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10911",
              children: "#10911"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["feat: update ", _jsx(_components.code, {
              children: "create-turbo"
            }), " Bun prompt text (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10918",
              children: "#10918"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["feat(microfrontends): schema.json for microfrontends.json (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/11008",
              children: "#11008"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["feat: Add support for custom microfrontends.json naming (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/11022",
              children: "#11022"
            }), ")"]
          }), "\n"]
        })
      }), _jsx(Accordion, {
        title: "Fixes (30)",
        children: _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: ["fix(microfrontends): ensure that local proxy is loose (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10289",
              children: "#10289"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(codemod): check for pipeline key before using it (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10295",
              children: "#10295"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(@turbo/repository): no longer require packageManager to detect npm (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10314",
              children: "#10314"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(watch): allow usage of turbo.jsonc (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10340",
              children: "#10340"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(dry): do not perform runtime validations on dry runs (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10375",
              children: "#10375"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(microfrontends): respect packageName field (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10383",
              children: "#10383"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(pnpm): read linkWorkspacePackages from pnpm-workspace.yaml (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10391",
              children: "#10391"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(query): use patched version of async-graphql (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10448",
              children: "#10448"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(turbo-ignore): no longer attempt to use catalog protocol (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10458",
              children: "#10458"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(@turbo/repository): correct exports from native lib (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10475",
              children: "#10475"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(turbo): pass through pnpm store env vars by default (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10520",
              children: "#10520"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(pnpm): respect deep for linkWorkspacePackages (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10558",
              children: "#10558"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(query): pin to last graphiql version with artifacts (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10685",
              children: "#10685"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(logs): no longer output group prefixes if no logs present (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10760",
              children: "#10760"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(turbo): graceful shutdown on sighup (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10764",
              children: "#10764"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(logs): create log files for non-cached tasks (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10806",
              children: "#10806"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(security): update dependencies to resolve warning for ", _jsx(_components.code, {
              children: "node-plop"
            }), " (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10847",
              children: "#10847"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix: revert #10847 (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10882",
              children: "#10882"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix: update ", _jsx(_components.code, {
              children: "ui"
            }), " suggested value in error message for turbo.json (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10896",
              children: "#10896"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(eslint-config-turbo): use module.exports for ESLint v8 compatibility (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10902",
              children: "#10902"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(turborepo-lockfiles): handle missing optional dependencies in Bun lockfiles (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10909",
              children: "#10909"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(lockfiles): include bundled dependencies in Bun lockfile subgraphs (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10915",
              children: "#10915"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix: update remote cache OAuth refresh flow (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10916",
              children: "#10916"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix: --graph=foo.dot should not require graphviz installed (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10942",
              children: "#10942"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix: ", _jsx(_components.code, {
              children: "injectWorkspacePackages"
            }), " for ", _jsx(_components.code, {
              children: "turbo prune"
            }), " with pnpm (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10945",
              children: "#10945"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix: adjust binary call for microfrontends proxy on Windows (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10962",
              children: "#10962"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix: added Linux env vars to global passthroughs (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10984",
              children: "#10984"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix: windows symlinking bug (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10992",
              children: "#10992"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix: path validation in ", _jsx(_components.code, {
              children: "microfrontends.json"
            }), " (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/11006",
              children: "#11006"
            }), ")"]
          }), "\n"]
        })
      }), _jsx(Accordion, {
        title: "Documentation (37)",
        children: _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: ["docs: clarification on Transit Nodes docs (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9181",
              children: "#9181"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(docs): fix SVG attribute casing to remove React warnings (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10297",
              children: "#10297"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(docs): update redirects rule to resolve access issue on ", _jsx(_components.code, {
              children: "getting-started"
            }), " index page (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10296",
              children: "#10296"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs(fix): persist tabs state (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10313",
              children: "#10313"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs(chore): remove classnames dependency (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10339",
              children: "#10339"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs(chore): remove ", _jsx(_components.code, {
              children: "/repo"
            }), " references from a few places (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10370",
              children: "#10370"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs(chore): add robots.txt (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10371",
              children: "#10371"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs(fix): better usability on feedback form (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10382",
              children: "#10382"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs(fix): logos when using system theme (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10388",
              children: "#10388"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs(chore): switch to ESM (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10405",
              children: "#10405"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs(fix): date of 2.5 release post (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10419",
              children: "#10419"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs(chore): temporarily revert to webpack (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10421",
              children: "#10421"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs(fix): layout shift on home page (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10424",
              children: "#10424"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs(chore): cleaning up a few todos (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10426",
              children: "#10426"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs(chore): reenable Turbopack (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10428",
              children: "#10428"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs(examples): drop JS config from Tailwind example (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10445",
              children: "#10445"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs(fix): correct ", _jsx(_components.code, {
              children: "globalDependencies"
            }), " defaults (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10484",
              children: "#10484"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs(example): use npx turbo and show filtering (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10500",
              children: "#10500"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs(fix): use ", _jsx(_components.code, {
              children: "pnpm add <pkg>"
            }), " instead of ", _jsx(_components.code, {
              children: "pnpm install <pkg>"
            }), " (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10529",
              children: "#10529"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs(fix): missing commas in package.json files of jest docs (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10560",
              children: "#10560"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs(fix): css import order bug in tailwindcss docs and example (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10561",
              children: "#10561"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs(fix): incorrect CSS filename in Tailwind CSS setup example (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10573",
              children: "#10573"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs(fix): inconsistent command with the illustration (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10596",
              children: "#10596"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs(fix): inconsistent turbo command with the illustration (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10602",
              children: "#10602"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: fix JSDoc type for ESLint config in basic example (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10727",
              children: "#10727"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs(run): correct --graph formats; remove incorrect default mention (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10744",
              children: "#10744"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs(run): fix --log-prefix options to match CLI (task, not prefix) (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10743",
              children: "#10743"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(docs): fix broken anchor links to --graph option (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10773",
              children: "#10773"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: add GitHub Actions reusable workflow documentation for remote caching (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10923",
              children: "#10923"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: generate blog release OG images (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10936",
              children: "#10936"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: fix correct package name from eslint-config-turbo to eslint-plugin-turbo (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10954",
              children: "#10954"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: adjust compute hours saved component initial value (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10958",
              children: "#10958"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: align tailwindcss 4 guide to the with-tailwind example  (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10963",
              children: "#10963"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: fix typos and formatting issues in Playwright guide (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10980",
              children: "#10980"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: clarify passthrough args comparison (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10990",
              children: "#10990"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: fix profile images on home page (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10993",
              children: "#10993"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: Clarify passthrough args cache miss (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/11026",
              children: "#11026"
            }), ")"]
          }), "\n"]
        })
      }), _jsx(Accordion, {
        title: "Examples (17)",
        children: _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: ["refactor(examples): enhance ", _jsx(_components.code, {
              children: "with-nestjs"
            }), " (#8131) (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10964",
              children: "#10964"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(examples): fix build in fresh vue example project (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10277",
              children: "#10277"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(non-monorepo): correct devDependency from 'turb' to 'turbo' (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10526",
              children: "#10526"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(examples): change docker command (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10362",
              children: "#10362"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(examples): ", _jsx(_components.code, {
              children: "with-svelte"
            }), " classes (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10363",
              children: "#10363"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["feat(examples): upgrade with-tailwind to TailwindCSS v4 (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10432",
              children: "#10432"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(examples): TypeScript in with-svelte example (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10450",
              children: "#10450"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["feat(example): update with-react-native-web, Expo SDK 52 (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10466",
              children: "#10466"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(examples): use entry instead of entryPoints (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10503",
              children: "#10503"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(example/with-docker): jest can't resolve @repo/jest-presets/node (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10551",
              children: "#10551"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(example): add missing Tailwind import to shared ui styles (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10579",
              children: "#10579"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["refactor(examples): remove duplicate Next.js plugin from app tsconfig files (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10612",
              children: "#10612"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(examples): css specificity in Tailwind example (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10657",
              children: "#10657"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["refactor(examples): update CSS variable names to use consistent --color- prefix in tailwind examples (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10662",
              children: "#10662"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(examples): vitest version upgrade (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10667",
              children: "#10667"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(examples): update vitest config paths for packages and apps in ", _jsx(_components.code, {
              children: "with-vitest"
            }), " (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10675",
              children: "#10675"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(examples): correct 'test:projects' script to use vitest directly (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10683",
              children: "#10683"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(examples): add missing extension to with-react-native-web ui tsconfig (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10694",
              children: "#10694"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["examples: Upgrade core-team-maintained examples to Next.js 16 (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/11014",
              children: "#11014"
            }), ")"]
          }), "\n"]
        })
      })]
    }), "\n", _jsx(_components.h2, {
      id: "acknowledgments-and-community",
      children: "Acknowledgments and community"
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo is the result of the combined work of all of its contributors, including our core team: ", _jsx(_components.a, {
        href: "https://github.com/anthonyshew",
        children: "Anthony"
      }), " and ", _jsx(_components.a, {
        href: "https://github.com/tknickman",
        children: "Tom"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["Thank you for your continued support, feedback, and collaboration to make Turborepo your build tool of choice. To learn how to get involved, ", _jsx(_components.a, {
        href: "/docs/community",
        children: "visit the Community page"
      }), "."]
    }), "\n", _jsx(_components.p, {
      children: "We also thank everyone who contributed to this release of Turborepo: @0ri0nexe, @0xmuon, @ahlimanhuseynov, @Alvi24, @andrewjdimola, @ashishkumar901336, @aviramha, @brunoapaulino, @chris-olszewski, @d0lwl0b, @DiegoDev2, @dstewart1911, @emilbjorklund, @eric-hjh, @esauri, @eug-vs, @evsasse, @felipetau, @Franck-Fernandez-pro, @grgsh, @haklee, @hijuliancode, @hugomassing, @JacksonSL, @JamesHenry, @jeonghwan-park, @jferrettiboke, @jihwan1211, @JoeyKamsteeg, @kade-robertson, @kenfdev, @kitfoster, @leopardracer, @mamuso, @mcky, @melroy, @MendyLanda, @mischnic, @mknichel, @mrr11k, @namidapoo, @NathanM2000, @neonerdy, @nivekithan, @ognevny, @oliveirabalsa, @pawbor, @pzion, @Redddy, @richardhuf84, @robbym, @robobun, @safaiyeh, @sahyl, @Satheeshsk369, @schwenkm, @sdavids, @shinjith-dev, @sitek94, @tedw, @tetzng, @vikhyathdevadiga, @xcfio, @yam-codes, and @yamadayutaka"
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
